import { createSelector } from '@reduxjs/toolkit';
import { selectJsonQuery } from './selectJsonQuery';
import { getRangeValue } from '../../../packages/JsonQuery';
import { DEFAULT_RANGE_VALUE } from 'shared/constants/defaultValues';

export const selectTotalArea = createSelector(
  selectJsonQuery,
  jsonQuery => getRangeValue('total_area')(jsonQuery) || DEFAULT_RANGE_VALUE,
);
